import { FC } from 'react';
import { TransparentModal as ModTransparentModal, ITransparentModalProps } from '@base/lib/TransparentModal';
import cn from 'classnames';
import styles from './index.module.less';

export const TransparentModal: FC<ITransparentModalProps> = props => {
    const { className, ...rest } = props;

    return (
        <ModTransparentModal
            className={cn(styles['trans-modal'], className)}
            {...rest}
        />
    )
};
